import RCAStatusBadge from "pages/Corporate/RCA/components/RCAStatusBadge";
import { useStyles } from "./IssueStatusCell.styles";
import { IIssueStatusCell } from "./IssueStatusCellInterfaces";
import { useTranslation } from "react-i18next";
import { DefaultTranslationFieldsInTable } from "constants/constants";
import { translateDefaultEntity } from "utilities/localesUtilities";

const IssueStatusCell = ({ issue, myDashboard }: IIssueStatusCell) => {
    const classes = useStyles();
    const { i18n } = useTranslation();
    return (
        <div className={myDashboard ? classes.wrapperMyDashboard : classes.wrapper}>
            <div className={classes.statusWrapper}>
                <RCAStatusBadge status={issue.status.status_id as unknown as number} className={classes.statusBadge} />
                <span>
                    {translateDefaultEntity(
                        i18n.language,
                        issue.status,
                        "name",
                        DefaultTranslationFieldsInTable.STATUS,
                    )}
                </span>
            </div>
        </div>
    );
};

export default IssueStatusCell;
